import React from 'react'
import CookieConsent from "react-cookie-consent";

const CookieBanner = ({yellow = false}) => {
    const bgColor = yellow ? "#ffd200" : "#e5e5e5";
    return (
        <CookieConsent
            location="bottom"
            buttonText="I understand"
            cookieName="cookie_accept"
            cookieValue="hide-msg"
            expires={365}
            buttonStyle={{backgroundColor: bgColor, fontFamily: 'MarfaIEFour-Regular', fontVariationSettings: '"wdth" 45'}}
            buttonClasses="cookie-consent-button"
            style={{alignItems: 'center', background: bgColor, fontSize: '.8em', color: "#000", lineHeight: 1, zIndex: 9999}}
        >
            <p style={{marginBottom: 0}}>
                We have placed cookies on your computer to help make this website better. <br />
                You can <a href="/cookies" style={{background: "#000000", color: "#e5e5e5", padding: "0 .2em"}} title="Visit all about cookies">change your cookie settings</a> at any time. Otherwise, we'll assume you're OK to continue.
            </p>
        </CookieConsent>
    )
}

export default CookieBanner;